import { CHART_CATALOG, type ChartId } from '../catalog/chartCatalog';

export function getChartPaletteOffset(chartId: ChartId | string): number {
  const index = CHART_CATALOG.findIndex((entry) => entry.id === chartId);
  return index >= 0 ? index : 0;
}

export function rotateChartPalette(
  palette: readonly string[],
  offset: number
): readonly string[] {
  if (palette.length === 0) {
    return palette;
  }

  const normalizedOffset =
    ((offset % palette.length) + palette.length) % palette.length;

  return [
    ...palette.slice(normalizedOffset),
    ...palette.slice(0, normalizedOffset),
  ];
}

export function resolveChartSeriesColors(
  chartId: ChartId | string,
  palette: readonly string[],
  sliceCount?: number
): readonly string[] {
  const rotated = rotateChartPalette(palette, getChartPaletteOffset(chartId));

  if (sliceCount === undefined) {
    return rotated;
  }

  return Array.from(
    { length: sliceCount },
    (_, index) => rotated[index % rotated.length] ?? rotated[0] ?? '#000000'
  );
}
